export enum ProductViewType {
  Customer = 'customer',
  Dealer = 'dealer'
}
